const DEFAULT_RESUBMISSION_HOUR = 9;

// one month ahead at 9:00, clamped to the last day of the target month (31.01. → 28./29.02.)
export const getDefaultResubmissionDate = (now: Date = new Date()): Date => {
    const lastDayOfTargetMonth = new Date(now.getFullYear(), now.getMonth() + 2, 0).getDate();
    return new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        Math.min(now.getDate(), lastDayOfTargetMonth),
        DEFAULT_RESUBMISSION_HOUR,
    );
};
